import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { useGetParams } from '../../hooks/useGetParams';
import { isCorrectLink } from '../../helpers/titreHelper';
import styles from './Photo.module.css';

import bgQuestionDefault from '../../assets/video/bgQuestion.webm';
import bgPosterQuestionDefault from '../../assets/images/bgPosterQuestion.webp';

export const Photo = ({ currentState, message = {} }) => {
  const { bgVideoQuestion, bgPosterQuestion, bgImgQuestion } = useGetParams();

  const { content, attachments } = message;
  const url = attachments?.[0]?.url;

  const [curMessage, setCurMessage] = useState({ url, content });

  useEffect(() => {
    if (currentState === 'S2' && url !== curMessage?.url) {
      setCurMessage({ url, content });
    }
  }, [currentState, url, content]);

  const textLines = curMessage?.content?.split(/\r?\n/);

  return (
    <div className={styles.photoWrapper}>
      <AnimatePresence mode="popLayout">
        {curMessage && (
          <motion.div
            className={styles.imgBlock}
            key={curMessage.url}
            initial={{ x: '-50vw' }}
            animate={{ x: currentState === 'S2' ? 0 : '50vw' }}
            exit={{ x: '100vw' }}
            transition={{ duration: 0.5 }}
          >
            <img src={curMessage.url} alt="attach" />
            <div className={styles.text}>
              {textLines[0] && (
                <div className={styles.firsLine}>{textLines[0].trim()}</div>
              )}
              {textLines[1] && (
                <div className={styles.secondLine}>{textLines[1].trim()}</div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ x: '50vw' }}
        animate={{ x: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.bgBlock}
      >
        {bgVideoQuestion &&
          (!bgImgQuestion || !isCorrectLink(bgImgQuestion)) && (
            <video
              autoPlay="autoplay"
              muted="muted"
              loop
              poster={
                bgVideoQuestion === '1'
                  ? bgPosterQuestionDefault
                  : bgPosterQuestion
              }
            >
              <source
                src={
                  bgVideoQuestion === '1' ? bgQuestionDefault : bgVideoQuestion
                }
              />
            </video>
          )}

        {bgImgQuestion && <img src={bgImgQuestion} alt="bg" />}
      </motion.div>
    </div>
  );
};
